export default {
  "mainVegetable": "gemueseart",
  "mainVegetable/01": "gemueseart/auberginen",
  "mainVegetable/02": "gemueseart/spargel",
  "mainVegetable/03": "gemueseart/avocado",
  "mainVegetable/04": "gemueseart/rueben",
  "mainVegetable/05": "gemueseart/brokkoli",
  "mainVegetable/06": "gemueseart/moehren",
  "mainVegetable/07": "gemueseart/sellerie",
  "mainVegetable/08": "gemueseart/pilze",
  "mainVegetable/09": "gemueseart/kohl",
  "mainVegetable/10": "gemueseart/rosenkohl",
  "mainVegetable/11": "gemueseart/chinakohl",
  "mainVegetable/12": "gemueseart/blumenkohl",
  "mainVegetable/13": "gemueseart/krautsalat",
  "mainVegetable/14": "gemueseart/gurke",
  "mainVegetable/15": "gemueseart/zucchini",
  "mainVegetable/16": "gemueseart/chicoree",
  "mainVegetable/17": "gemueseart/spinat",
  "mainVegetable/18": "gemueseart/saubohne",
  "mainVegetable/19": "gemueseart/flageolets",
  "mainVegetable/20": "gemueseart/stangenbohnen",
  "mainVegetable/21": "gemueseart/getrocknete-bohnen",
  "mainVegetable/22": "gemueseart/gruene-bohnen",
  "mainVegetable/23": "gemueseart/linsen",
  "mainVegetable/24": "gemueseart/macedoine-gemuese",
  "mainVegetable/25": "gemueseart/mais",
  "mainVegetable/26": "gemueseart/mesclun",
  "mainVegetable/27": "gemueseart/steckruebe",
  "mainVegetable/28": "gemueseart/zwiebeln",
  "mainVegetable/29": "gemueseart/erbsen",
  "mainVegetable/30": "gemueseart/paprika",
  "mainVegetable/31": "gemueseart/kartoffeln",
  "mainVegetable/32": "gemueseart/sojasprossen",
  "mainVegetable/33": "gemueseart/radieschen",
  "mainVegetable/34": "gemueseart/blattsalat",
  "mainVegetable/35": "gemueseart/frisee",
  "mainVegetable/36": "gemueseart/eisbergsalat",
  "mainVegetable/37": "gemueseart/piemont-salat",
  "mainVegetable/38": "gemueseart/reissalat",
  "mainVegetable/39": "gemueseart/romanasalat",
  "mainVegetable/40": "gemueseart/junge-triebe",
  "mainVegetable/41": "gemueseart/kopfsalat",
  "mainVegetable/42": "gemueseart/feldsalat",
  "mainVegetable/43": "gemueseart/rucola",
  "mainVegetable/44": "gemueseart/schwarzwurzeln",
  "mainVegetable/45": "gemueseart/tabouleh",
  "mainVegetable/46": "gemueseart/tomaten",
  "mainVegetable/47": "gemueseart/wachsbohnen",
  "mainVegetable/48": "gemueseart/kichererbsen",
  "mainVegetable/49": "gemueseart/lauch",
  "mainVegetable/50": "gemueseart/kuerbis",
  "mainVegetable/51": "gemueseart/kidney-bohnen",
  "mainVegetable/52": "gemueseart/apfel",
  "mainVegetable/53": "gemueseart/maronen",
  "mainVegetable/54": "gemueseart/backpflaume",
  "mainVegetable/55": "gemueseart/pflanzkasten",
  "mainVegetable/56": "gemueseart/schwarze-oliven",
  "mainVegetable/57": "gemueseart/artischocken",
  "mainVegetable/58": "gemueseart/roter-paprika",
  "mainVegetable/59": "gemueseart/gruene-bohnen",
  "mainVegetable/60": "gemueseart/fruehling",
  "mainVegetable/61": "gemueseart/ratatouille",
  "mainVegetable/62": "gemueseart/couscous",
  "mainVegetable/63": "gemueseart/tajine",
  "mainVegetable/64": "gemueseart/curry-gemuese",
  "mainVegetable/65": "gemueseart/erbsen",
  "mainVegetable/66": "gemueseart",
  "mainVegetable/67": "gemueseart/linsen",
  "mainVegetable/68": "gemueseart/quinoa",
  "mainVegetable/69": "gemueseart/dinkel",
  "mainVegetable/70": "gemueseart/bulgur",
  "mainVegetable/71": "gemueseart/rotkohl",
  "mainVegetable/72": "gemueseart/kale",
  "mainVegetable/73": "gemueseart/kerbel",
  "mainVegetable/74": "gemueseart/grains-und-samen",
  "mainVegetable/75": "gemueseart/leguminosen",
  "mainVegetable/76": "gemueseart/potato-suess",
  "mainVegetable/77": "gemueseart/kuerbis",
  "mainVegetable/78": "gemueseart/sauerampfer",
  "mainVegetable/79": "gemueseart/bohnen",
  "mainVegetable/80": "gemueseart/erbsen-karotten",
  "mainVegetable/81": "gemueseart/erbsen",
  "mainVegetable/82": "gemueseart/edamame",
  "mainVegetable/83": "gemueseart/orzo",
  "mainVegetable/84": "gemueseart/mix-di-insalate",
  "mainVegetable/85": "gemueseart/pan-di-zucchero",
  "mainVegetable/86": "gemueseart/songino",
  "mainVegetable/87": "gemueseart/spinacino",
  "mainVegetable/88": "gemueseart/lattughino",
  "mainVegetable/89": "gemueseart/lollo-verde",
  "mainVegetable/90": "gemueseart",
  "mainVegetable/91": "gemueseart",
  "mainVegetable/92": "gemueseart",
  "mainVegetable/93": "gemueseart",
  "mainVegetable/94": "gemueseart",
  "mainVegetable/95": "gemueseart",
  "mainVegetable/96": "gemueseart",
  "mainVegetable/97": "gemueseart",
  "mainVegetable/98": "gemueseart",
  "season": "saison",
  "season/1": "saison/sommer",
  "season/2": "saison/herbst",
  "season/3": "saison/winter",
  "season/4": "saison/fruehling",
  "season/5": "saison",
  "technologie": "technologie",
  "technologie/AC01": "technologie/gemuesekonserve",
  "technologie/AD01": "technologie/tiefkuehl",
  "technologie/AG01": "technologie/frische",
  "technologie/AT01": "technologie/gastronomie",
  "recipeDish": "menueart",
  "recipeDish/ACC": "menueart",
  "recipeDish/APE": "menueart/vorspeise",
  "recipeDish/DES": "menueart/nachtisch-und-backwaren",
  "recipeDish/ENT": "menueart/vorspeisen-und-suppen",
  "recipeDish/PLAT": "menueart/hauptgang",
  "recipeDish/SAL": "menueart/salate-und-grillen",
  "recipeDish/SNA": "menueart/snacks-und-fingerfood",
  "recipeDish/PDE": "menueart",
  "recipeDish/DEJ": "menueart",
  "recipeDish/TRA": "menueart",
  "recipeDish/GOU": "menueart",
  "recipeDish/ETH": "menueart",
  "recipeDish/FCH": "menueart",
  "recipeDish/SOU": "menueart",
  "pred-recipeTimingCook-facet": "kochen-backen",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "kochen-backen/0-15-minuten",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "kochen-backen/15-30-minuten",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "kochen-backen/30-45-minuten",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "kochen-backen/45-minuten",
  "pred-recipeTimingPreparation-facet": "vorbereitungszeit",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "vorbereitungszeit/0-15-minuten",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "vorbereitungszeit/15-30-minuten",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "vorbereitungszeit/30-45-minuten",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "vorbereitungszeit/45-minuten",
  "pred-recipeCost-Facet": "kosten",
  "pred-recipeCost-Facet/petit": "kosten/klein",
  "pred-recipeCost-Facet/moyen": "kosten/mittel",
  "pred-recipeCost-Facet/grand": "kosten/gross",
  "recipeDifficulty": "schwierigkeitsgrad",
  "recipeDifficulty/1": "schwierigkeitsgrad/einfach",
  "recipeDifficulty/2": "schwierigkeitsgrad/mittel",
  "recipeDifficulty/3": "schwierigkeitsgrad/schwer",
  "recipeDishNumber": "portionen",
  "recipeDishNumber/1": "portionen/1",
  "recipeDishNumber/2": "portionen/2",
  "recipeDishNumber/3": "portionen/3",
  "recipeDishNumber/4": "portionen/4",
  "recipeDishNumber/5": "portionen/5",
  "recipeDishNumber/6": "portionen/6",
  "recipeDishNumber/7": "portionen/7",
  "recipeDishNumber/8": "portionen/8",
  "cultureType": "kulturtyp",
  "cultureType/Bio": "kulturtyp/bio",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "kulturtyp",
  "cultureType/Sans%20OGM": "kulturtyp",
  "nutriscore": "nutriscore",
  "pred-particularite": "Ernaehrungsweise",
  "pred-particularite/recipeVegan": "Ernaehrungsweise/vegan",
  "pred-particularite/recipeVeggie": "Ernaehrungsweise/vegetarisch",
  "pred-particularite/recipeGlutenfree": "Ernaehrungsweise/glutenfrei",
  "pred-particularite/recipeLactosefree": "Ernaehrungsweise/laktosefrei"
};
